import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-md-center" }
const _hoisted_2 = { class: "col-md-12 col-lg-6" }
const _hoisted_3 = { class: "row m-0" }
const _hoisted_4 = { class: "col-md-6 col-lg-3" }
const _hoisted_5 = {
  class: "row m-4",
  style: {"min-width":"230px"}
}
const _hoisted_6 = {
  class: "row m-4",
  style: {"min-width":"230px"}
}
const _hoisted_7 = { class: "col-md-6 col-lg-3" }
const _hoisted_8 = {
  class: "row m-4",
  style: {"min-width":"230px"}
}
const _hoisted_9 = {
  class: "row m-4",
  style: {"min-width":"230px"}
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-xl-4" }
const _hoisted_12 = { class: "row m-4 me-0" }
const _hoisted_13 = { class: "col-xl-4" }
const _hoisted_14 = { class: "row m-4" }
const _hoisted_15 = { class: "col-xl-4" }
const _hoisted_16 = { class: "row mt-7 me-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardTotal = _resolveComponent("DashboardTotal")!
  const _component_AlertTotal = _resolveComponent("AlertTotal")!
  const _component_ChargebackWidget1 = _resolveComponent("ChargebackWidget1")!
  const _component_MerchantWidget1 = _resolveComponent("MerchantWidget1")!
  const _component_AlertWidget1 = _resolveComponent("AlertWidget1")!
  const _component_TransactionWidget1 = _resolveComponent("TransactionWidget1")!
  const _component_PerformanceWidget1 = _resolveComponent("PerformanceWidget1")!
  const _component_NotificationsWidget1 = _resolveComponent("NotificationsWidget1")!
  const _component_PreventionWidget1 = _resolveComponent("PreventionWidget1")!
  const _component_AddAlertSubdomainDrawer = _resolveComponent("AddAlertSubdomainDrawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_DashboardTotal, {
          "widget-classes": "card mt-4 p-1",
          "chart-height": "120",
          amount: _ctx.amount
        }, null, 8, ["amount"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_AlertTotal, {
            "widget-classes": "card mt-4 p-1",
            "chart-height": "120",
            amount: _ctx.amount
          }, null, 8, ["amount"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_ChargebackWidget1, {
            "widget-classes": "card-xl p-0",
            color: "muted",
            title: "sent to bank",
            description: "Responded",
            progress: `${_ctx.responded}%`,
            amount: _ctx.amount,
            count: _ctx.count
          }, null, 8, ["progress", "amount", "count"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_MerchantWidget1, {
            "widget-classes": "card-xl-stretch p-0",
            color: "muted",
            title: "sent to bank",
            description: "Responded",
            progress: `${_ctx.responded}%`
          }, null, 8, ["progress"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_AlertWidget1, {
            "widget-classes": "card-xl p-0",
            color: "muted",
            title: "transctactions found",
            description: "Matched",
            progress: `${_ctx.matched}%`
          }, null, 8, ["progress"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_TransactionWidget1, {
            "widget-classes": "card-xl p-0",
            color: "muted",
            title: "transctactions found",
            description: "Matched",
            progress: `${_ctx.matched}%`,
            totalSpent: _ctx.totalSpent,
            totalRecovered: _ctx.totalRecovered,
            roi: _ctx.roi
          }, null, 8, ["progress", "totalSpent", "totalRecovered", "roi"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_PerformanceWidget1, {
            "widget-classes": "card-xl p-0",
            color: "muted",
            title: "transctactions found",
            description: "Matched",
            progress: `${_ctx.matched}%`,
            totalSpent: _ctx.totalSpent,
            totalRecovered: _ctx.totalRecovered,
            roi: _ctx.roi
          }, null, 8, ["progress", "totalSpent", "totalRecovered", "roi"])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_NotificationsWidget1, {
            "widget-classes": "card-xl p-0",
            color: "muted",
            title: "sent to bank",
            description: "Responded",
            progress: `${_ctx.responded}%`,
            amount: _ctx.amount,
            count: _ctx.count
          }, null, 8, ["progress", "amount", "count"])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_PreventionWidget1)
        ])
      ])
    ]),
    _createVNode(_component_AddAlertSubdomainDrawer)
  ], 64))
}